(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velmont-announcement')) {
    customElements.define(
      'velmont-announcement',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('.v-announce__item')];
          if (this.items.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.index = 0;
          this.timer = setInterval(() => this.next(), Number(this.dataset.speed) || 5000);
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        next() {
          if (this.paused) return;
          this.items[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-article"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.vpost__copy');
    if (!btn || !navigator.clipboard) return;
    navigator.clipboard.writeText(btn.dataset.copy).then(() => {
      const label = btn.querySelector('.vpost__copy-text');
      const original = label.textContent;
      label.textContent = 'Link copied';
      setTimeout(() => (label.textContent = original), 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-collection"]) return;
  try {
    
  if (!customElements.get('velmont-collection')) {
    customElements.define(
      'velmont-collection',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.addEventListener('click', (e) => this.onClick(e));
          this.addEventListener('change', (e) => this.onChange(e));
          this.addEventListener('input', (e) => this.onInput(e));
          this.addEventListener('keyup', (e) => e.key === 'Escape' && this.closeFilters());
          this.onPop = () => this.render(location.href, false);
          window.addEventListener('popstate', this.onPop);
          this.initPrice();
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.onPop);
        }

        get form() {
          return this.querySelector('.vcol__form');
        }

        onClick(e) {
          if (e.target.closest('[data-filters-open]')) return this.openFilters();
          if (e.target.closest('[data-filters-close]')) return this.closeFilters();
          const link = e.target.closest('a[data-facet-link]');
          if (link) {
            e.preventDefault();
            this.render(link.href);
          }
        }

        onChange(e) {
          const t = e.target;
          if (t.matches('[data-range-min], [data-range-max]')) return this.submit(400);
          if (t.form === this.form || t.matches('[data-sort]')) this.submit(t.type === 'number' ? 500 : 0);
        }

        onInput(e) {
          const t = e.target;
          if (t.matches('[data-range-min], [data-range-max]')) this.syncFromRange(t);
          if (t.matches('[data-input-min], [data-input-max]')) this.syncFromInputs();
        }

        initPrice() {
          const wrap = this.querySelector('[data-price-range]');
          if (!wrap) return;
          this.price = {
            wrap,
            rMin: wrap.querySelector('[data-range-min]'),
            rMax: wrap.querySelector('[data-range-max]'),
            iMin: wrap.querySelector('[data-input-min]'),
            iMax: wrap.querySelector('[data-input-max]'),
            fill: wrap.querySelector('[data-fill]'),
          };
          this.paintRange();
        }

        paintRange() {
          const p = this.price;
          if (!p) return;
          const max = Number(p.rMax.max) || 1;
          p.wrap.style.setProperty('--lo', (Number(p.rMin.value) / max) * 100 + '%');
          p.wrap.style.setProperty('--hi', (Number(p.rMax.value) / max) * 100 + '%');
        }

        syncFromRange(changed) {
          const p = this.price;
          let lo = Number(p.rMin.value);
          let hi = Number(p.rMax.value);
          if (lo > hi) {
            if (changed === p.rMin) p.rMin.value = lo = hi;
            else p.rMax.value = hi = lo;
          }
          const max = Number(p.rMax.max);
          p.iMin.value = lo > 0 ? lo : '';
          p.iMax.value = hi < max ? hi : '';
          this.paintRange();
        }

        syncFromInputs() {
          const p = this.price;
          const max = Number(p.rMax.max);
          p.rMin.value = p.iMin.value === '' ? 0 : Math.min(Number(p.iMin.value), max);
          p.rMax.value = p.iMax.value === '' ? max : Math.min(Number(p.iMax.value), max);
          this.paintRange();
        }

        submit(delay) {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => {
            const params = new URLSearchParams(new FormData(this.form));
            for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
            this.render(`${location.pathname}?${params.toString()}`);
          }, delay);
        }

        async render(href, push = true) {
          const url = new URL(href, location.origin);
          const fetchUrl = new URL(url);
          fetchUrl.searchParams.set('section_id', this.sectionId);
          // Remember focus so keyboard users stay in place after the re-render
          const active = document.activeElement;
          let focusId = null;
          if (active && this.contains(active)) {
            if (active.matches('[data-sort]')) focusId = 'sort';
            else if (active.id) focusId = active.id;
          }
          this.classList.add('is-loading');
          try {
            const res = await fetch(fetchUrl);
            const html = new DOMParser().parseFromString(await res.text(), 'text/html');
            const fresh = html.querySelector('velmont-collection');
            if (!fresh) throw new Error('No section');
            const openGroups = [...this.querySelectorAll('.vcol__group')].map((d) => d.open);
            this.innerHTML = fresh.innerHTML;
            this.querySelectorAll('.vcol__group').forEach((d, i) => {
              if (openGroups[i] === false) d.open = false;
            });
            this.initPrice();
            if (push) history.pushState({}, '', url.pathname + url.search);
            if (focusId === 'sort') this.querySelector('[data-sort]')?.focus();
            else if (focusId) document.getElementById(focusId)?.focus();
            if (!this.classList.contains('filters-open') && push && !focusId) {
              const top = this.getBoundingClientRect().top + window.scrollY - 120;
              if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
            }
          } catch (err) {
            location.href = url.href;
          } finally {
            this.classList.remove('is-loading');
          }
        }

        openFilters() {
          this.classList.add('filters-open');
          document.body.classList.add('overflow-hidden');
          this.querySelector('[data-filters-open]')?.setAttribute('aria-expanded', 'true');
          this.querySelector('.vcol__sidebar').focus?.();
        }

        closeFilters() {
          if (!this.classList.contains('filters-open')) return;
          this.classList.remove('filters-open');
          document.body.classList.remove('overflow-hidden');
          const btn = this.querySelector('[data-filters-open]');
          btn?.setAttribute('aria-expanded', 'false');
          btn?.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-header"]) return;
  try {
    
  if (!customElements.get('velmont-header')) {
    customElements.define(
      'velmont-header',
      class extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('.vh-drawer');
          this.panel = this.querySelector('.vh-drawer__panel');
          this.openBtn = this.querySelector('[data-drawer-open]');
          this.search = this.querySelector('.vh__search');
          this.searchToggles = this.querySelectorAll('[data-search-toggle]');

          this.openBtn.addEventListener('click', () => this.openDrawer());
          this.querySelectorAll('[data-drawer-close]').forEach((el) =>
            el.addEventListener('click', () => this.closeDrawer())
          );
          this.searchToggles.forEach((el) => el.addEventListener('click', () => this.toggleSearch()));

          this.onKeyup = (event) => {
            if (event.key !== 'Escape') return;
            if (!this.drawer.hidden) this.closeDrawer();
            else if (!this.search.hidden) this.toggleSearch(false);
          };
          document.addEventListener('keyup', this.onKeyup);
        }

        disconnectedCallback() {
          document.removeEventListener('keyup', this.onKeyup);
          document.body.classList.remove('overflow-hidden');
        }

        openDrawer() {
          this.drawer.hidden = false;
          this.openBtn.setAttribute('aria-expanded', 'true');
          document.body.classList.add('overflow-hidden');
          requestAnimationFrame(() => {
            this.drawer.classList.add('is-open');
            this.panel.focus();
          });
          if (typeof trapFocus === 'function') trapFocus(this.panel);
        }

        closeDrawer() {
          this.drawer.classList.remove('is-open');
          this.openBtn.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden');
          if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openBtn);
          setTimeout(() => (this.drawer.hidden = true), 350);
        }

        toggleSearch(force) {
          const open = typeof force === 'boolean' ? force : this.search.hidden;
          this.search.hidden = !open;
          this.searchToggles.forEach((el) => el.setAttribute('aria-expanded', String(open)));
          if (open) this.search.querySelector('input[type="search"]').focus();
          else this.searchToggles[0].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velmont-slider')) {
    customElements.define(
      'velmont-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.vhero__slide')];
          this.dots = [...this.querySelectorAll('.vhero__dot')];
          this.index = 0;
          if (this.slides.length < 2) return;

          this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true));
          this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go), true)));

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.autoplay === 'true' && !reduce) {
            this.addEventListener('mouseenter', () => (this.paused = true));
            this.addEventListener('mouseleave', () => (this.paused = false));
            this.addEventListener('focusin', () => (this.paused = true));
            this.addEventListener('focusout', () => (this.paused = false));
            this.timer = setInterval(() => !this.paused && this.go(this.index + 1), Number(this.dataset.speed) || 6000);
          }

          // Theme editor: show the selected slide
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) this.go(i, true);
          });
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        go(target, user) {
          const n = this.slides.length;
          const next = (target + n) % n;
          if (user) {
            clearInterval(this.timer);
            this.timer = null;
          }
          this.slides.forEach((slide, i) => {
            const active = i === next;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('inert', !active);
            if (active) slide.removeAttribute('aria-hidden');
            else slide.setAttribute('aria-hidden', 'true');
          });
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === next);
            if (i === next) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.index = next;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-product"]) return;
  try {
    
  if (!customElements.get('velmont-product')) {
    customElements.define(
      'velmont-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
          this.form = this.querySelector('form.vp__form');
          this.stage = this.querySelector('[data-stage]');
          this.slides = [...this.querySelectorAll('.vp__slide')];

          this.addEventListener('change', (e) => {
            if (e.target.matches('[data-option]')) this.onOptionChange();
            if (e.target.matches('[data-engrave-toggle]')) this.toggleEngraving(e.target.checked);
            if (e.target.matches('[data-font-choice]')) this.setPreviewFont(e.target.dataset.fontChoice);
            if (e.target.matches('[data-place-choice]')) this.setPreviewPlace(e.target.value);
          });
          this.addEventListener('input', (e) => {
            if (e.target.matches('[data-engrave-input]')) this.onEngraveInput(e.target);
          });
          this.addEventListener('click', (e) => {
            const thumb = e.target.closest('[data-thumb]');
            if (thumb) this.showMedia(thumb.dataset.thumb, true);
            const qty = e.target.closest('[data-qty]');
            if (qty) this.stepQty(Number(qty.dataset.qty));
          });
          // Capture phase: validate engraving before Dawn's product-form submits
          this.addEventListener('submit', (e) => this.validate(e), true);

          if (this.stage && this.slides.length > 1) {
            this.stage.addEventListener('scroll', () => this.onScroll(), { passive: true });
          }
          this.updateAvailability();
          const toggle = this.querySelector('[data-engrave-toggle]');
          if (toggle) this.toggleEngraving(toggle.checked);
        }

        /* ---------- Variants ---------- */
        selectedOptions() {
          return [...this.querySelectorAll('[data-option-index]')].map(
            (fs) => fs.querySelector('[data-option]:checked')?.value
          );
        }

        onOptionChange() {
          const selected = this.selectedOptions();
          this.querySelectorAll('[data-option-index]').forEach((fs, i) => {
            const label = fs.querySelector('[data-option-value]');
            if (label) label.textContent = selected[i];
          });
          const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));
          const idInput = this.form.querySelector('[data-variant-id]');
          const add = this.querySelector('[data-add]');
          const addText = this.querySelector('[data-add-text]');

          if (!variant) {
            add.disabled = true;
            addText.textContent = this.strings.unavailable;
            return;
          }
          idInput.value = variant.id;
          this.querySelector('[data-price-current]').textContent = variant.price;
          const compare = this.querySelector('[data-price-compare]');
          compare.hidden = !variant.compare;
          if (variant.compare) compare.textContent = variant.compare;
          add.disabled = !variant.available;
          addText.textContent = variant.available ? this.strings.add : this.strings.soldOut;
          if (variant.media) this.showMedia(String(variant.media), false);

          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.pathname + url.search);
          this.updateAvailability();
        }

        updateAvailability() {
          const selected = this.selectedOptions();
          this.querySelectorAll('[data-option-index]').forEach((fs, i) => {
            fs.querySelectorAll('[data-option]').forEach((input) => {
              const combo = [...selected];
              combo[i] = input.value;
              const ok = this.variants.some((v) => v.available && v.options.every((o, j) => o === combo[j]));
              input.nextElementSibling?.classList.toggle('is-unavailable', !ok);
            });
          });
        }

        /* ---------- Gallery ---------- */
        showMedia(id, focus) {
          const idx = this.slides.findIndex((s) => s.dataset.mediaId === id);
          if (idx < 0) return;
          this.slides.forEach((s, i) => {
            s.classList.toggle('is-active', i === idx);
            const video = s.querySelector('video');
            if (!video) return;
            if (i === idx) video.play().catch(() => {});
            else video.pause();
          });
          this.querySelectorAll('[data-thumb]').forEach((t) => {
            const on = t.dataset.thumb === id;
            t.classList.toggle('is-active', on);
            if (on) t.setAttribute('aria-current', 'true');
            else t.removeAttribute('aria-current');
          });
          if (this.stage.scrollWidth > this.stage.clientWidth) {
            this.stage.scrollTo({ left: this.slides[idx].offsetLeft - this.stage.offsetLeft, behavior: 'smooth' });
          }
          const counter = this.querySelector('[data-counter]');
          if (counter) counter.textContent = idx + 1;
        }

        onScroll() {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            const idx = Math.round(this.stage.scrollLeft / this.stage.clientWidth);
            this.slides.forEach((s, i) => {
              const video = s.querySelector('video');
              if (!video) return;
              if (i === idx) video.play().catch(() => {});
              else video.pause();
            });
            const counter = this.querySelector('[data-counter]');
            if (counter) counter.textContent = idx + 1;
          }, 80);
        }

        stepQty(delta) {
          const input = this.querySelector('[data-qty-input]');
          input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
        }

        /* ---------- Engraving ---------- */
        toggleEngraving(on) {
          const body = this.querySelector('[data-engrave-body]');
          if (!body) return;
          body.hidden = !on;
          // Disabled fields are not submitted, so no empty properties reach the cart
          body.querySelectorAll('input').forEach((i) => (i.disabled = !on));
          if (on) {
            const input = body.querySelector('[data-engrave-input]');
            this.onEngraveInput(input);
          } else {
            this.showEngraveError(false);
          }
        }

        onEngraveInput(input) {
          const clean = input.value.replace(/[^A-Za-z0-9&.'\- ]/g, '');
          if (clean !== input.value) input.value = clean;
          this.querySelector('[data-chars]').textContent = input.value.length;
          const text = this.querySelector('[data-preview-text]');
          const value = input.value.trim();
          text.textContent = value || text.dataset.empty;
          text.classList.toggle('is-empty', !value);
          if (value) this.showEngraveError(false);
        }

        setPreviewFont(font) {
          this.querySelector('[data-preview]').dataset.font = font;
        }

        setPreviewPlace(place) {
          this.querySelector('[data-preview-place]').textContent = place;
        }

        showEngraveError(show) {
          const err = this.querySelector('[data-engrave-error]');
          const input = this.querySelector('[data-engrave-input]');
          if (!err) return;
          err.hidden = !show;
          if (show) input.setAttribute('aria-invalid', 'true');
          else input.removeAttribute('aria-invalid');
        }

        validate(e) {
          const toggle = this.querySelector('[data-engrave-toggle]');
          const input = this.querySelector('[data-engrave-input]');
          if (toggle?.checked && input && !input.value.trim()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.showEngraveError(true);
            input.focus();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velmont-related"]) return;
  try {
    
  if (!customElements.get('velmont-related')) {
    customElements.define(
      'velmont-related',
      class extends HTMLElement {
        connectedCallback() {
          if (this.children.length) return;
          const load = () =>
            fetch(this.dataset.url)
              .then((r) => r.text())
              .then((text) => {
                const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('velmont-related');
                if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
              })
              .catch(() => {});
          if (!('IntersectionObserver' in window)) return load();
          new IntersectionObserver(
            (entries, obs) => {
              if (!entries[0].isIntersecting) return;
              obs.disconnect();
              load();
            },
            { rootMargin: '0px 0px 400px 0px' }
          ).observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
